import { SquaayAndroidLink, SquaayIOSLink } from "../../common/constant";
import "./DownloadOptions.css";

export default function DownloadOptions() {
  const stores = [
    {
      name: "App Store",
      description:
        "Download the iOS app for faster ordering and exclusive offers.",
      url: SquaayIOSLink,
      icon: "",
    },
    {
      name: "Google Play",
      description: "Install the Android app to enjoy Squaay on the go.",
      url: SquaayAndroidLink,
      icon: "▶",
    },
  ];

  return (
    <section className="download-options">
      <div className="download-options__header">
        <p className="download-options__eyebrow">Mobile App</p>
        <h2 className="download-options__title">Download the Squaay app</h2>
        <p className="download-options__subtitle">
          Get the full Squaay experience with one tap. Fast checkout, order
          tracking, and the easiest way to stay connected with your favourite
          food vendors.
        </p>
      </div>

      <div className="download-options__cards">
        {stores.map((store) => (
          <article key={store.name} className="download-card">
            <div className="download-card__top">
              <div className="download-card__icon">{store.icon}</div>
              <div className="download-card__content">
                <h3>{store.name}</h3>
                <p className="download-card__text">{store.description}</p>
              </div>
            </div>
            <div className="download-card__action">
              <a
                className="download-card__button"
                href={store.url}
                target="_blank"
                rel="noopener noreferrer"
              >
                {`Download on ${store.name}`}
              </a>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}
